// extracted by mini-css-extract-plugin
export default {"fontColorb":"#1788EE","fontColord":"#404D57","fontColor1":"#6F8393"};